import { CommonModule } from "@angular/common";
import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TranslocoModule } from "@ngneat/transloco";

@Component({
    selector: "ac-button",
    standalone: true,
    imports: [CommonModule, MatProgressSpinnerModule, TranslocoModule],
    templateUrl: "./ac-button.component.html",
    styleUrls: ["./ac-button.component.scss"],
    encapsulation: ViewEncapsulation.None,
    host: {
        // Añadir el hostListener: none al componente para prevenir clicks cuando está deshabilitado
        "[style.pointer-events]": 'isDisabled ? "none" : "auto"',
    },
})
export class AcButtonComponent implements OnChanges {
    @Input() color: "primary" | "secondary" | "light" | "dark" | "muted" | "success" | "danger" | "warning" | "default" = "default";
    @Input() disabled: boolean | string = false;
    @Input() loading: boolean = false;
    @Input() type: "icon" | "text" | "outline" | "raised" | "pill" | "default" = "default";

    @Output() clicked: EventEmitter<void> = new EventEmitter();

    public isDisabled: boolean = false;

    @HostBinding("style.pointerEvents")
    get pointerEvents(): string {
        return this.isDisabled || this.loading ? "none" : "auto";
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disabled) {
            this.isDisabled = [true, "true", "", "disabled"].includes(this.disabled);
        }
    }

    handleClick(event: Event): void {
        // Most consumers listen with (click) on the host, so the event must not bubble out either:
        // a second click on a button that is still saving would repeat the request.
        if (this.isDisabled || this.loading) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        this.clicked.emit();
    }
}
